(ns bedrock-ui.sentry.db)

(def root [:sentry])
(def report-dialog-last-shown-path (conj root :report-dialog-last-shown))

(defn set-report-dialog-last-shown
  [db time]
  (assoc-in db report-dialog-last-shown-path time))

(defn get-report-dialog-last-shown
  [db]
  (get-in db report-dialog-last-shown-path))
